<mat-card class="cardWithShadow">
  <mat-card-content>

    <div class="container_button_company">
      <mat-card-title>Clientes</mat-card-title>
      <button type="button" mat-stroked-button color="primary" (click)="AddClient()">
        Añadir Clientes
      </button>
    </div>

    <div class="spinner">
      <mat-spinner [diameter]="60" *ngIf="booleanFlag == true"></mat-spinner>
      <h1 *ngIf="booleanText == false">No hay Clientes</h1>
    </div>
    
    <div class="table-responsive m-t-30" [class.esconder]="booleanFlag == true || booleanText == false" >
      <table mat-table [dataSource]="dataSource" class="w-100" matSort
      (matSortChange)="changeSortingTable($event)">

        <ng-container matColumnDef="Name">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="th-title">
            Nombre
          </th>
          <td mat-cell *matCellDef="let element" (click)="dealDialogOpen(element.companyId)"
            style="text-decoration: underline; color: blue; cursor: pointer">
            <h6>
              {{ element.name }}
            </h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="ClientRut">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Rut
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
            <h6>
              {{ element.clientRut }}
            </h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="SIIPasswordUpdate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Actualizacion de Constraseña de SII
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
            <h6>
              {{ element.siiPasswordUpdate | date : "dd-MM-yyyy" }}
            </h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="StartCurrentActivities">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Inicio de Actividades
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
            <h6>
              {{ element.startCurrentActivities | date : "dd-MM-yyyy" }}
            </h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="IsSiiConnected">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <img src="/assets/images/logos/Logo_de_Servicio_de_Impuestos_Internos.svg" alt="google" width="18" />
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1" style="text-align: center;">
            <i-tabler *ngIf="element.isSiiConnected == true" name="circle-check-filled" class="icon-20"
              style="color: mediumspringgreen"></i-tabler>

            <i-tabler *ngIf="element.isSiiConnected == false" name="circle-x-filled" class="icon-20"
              style="color: red"></i-tabler>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="cursor-table" *matRowDef="let row; columns: displayedColumns"></tr>

      </table>
      <mat-paginator (page)="changePaginationTable($event)" [pageSizeOptions]="[10, 25, 100]"></mat-paginator>

    </div>
  </mat-card-content>
</mat-card>